import { NgIf } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SideBarComponent } from '../../shared/components/side-bar/side-bar.component';
import { TopBarComponent } from '../../shared/components/top-bar/top-bar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-home-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    NgIf,
    SideBarComponent,
    TopBarComponent
  ],
  templateUrl: './home-layout.component.html',
  styleUrl: './home-layout.component.css'
})
export class HomeLayoutComponent {
  isCollapsed = false;        // desktop collapsed (64px)
  isMobileOpen = false;       // mobile slide-in
  private mobileBreakpoint = 768;
  openGroupKey: string | null = null;

  currentYear = new Date().getFullYear();

  constructor(
    private toasterService: ToastrService
  ) { }

  onExpandRequest(groupKey: string) {
    this.isCollapsed = false;        // expand sidebar
    this.openGroupKey = groupKey;    // tell sidebar which group to open
    setTimeout(() => this.openGroupKey = null, 0); // reset after next tick (optional)
  }

  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth >= this.mobileBreakpoint) {
      this.isMobileOpen = false; // close overlay mode when back to desktop
    }
  }

  onToggleSidebar() {
    if (window.innerWidth < this.mobileBreakpoint) {
      this.isMobileOpen = !this.isMobileOpen;
    } else {
      this.isCollapsed = !this.isCollapsed;
    }
  }

  onBackdropClick() { this.isMobileOpen = false; }

  notDeveloped(): void {
    this.toasterService.info('This feature is not implemented yet.', 'Coming Soon');
  }
}
